module.exports = __webpack_public_path__ + "5ac5496fe41eea31775a5e5ab001b727.MP3";